"use client";

export default function Divider() {
	return <hr className="mb-[40px] mt-[48px] h-[1px] w-full bg-layoutDivider" />;
}
